import { useNavigate } from "react-router-dom";
import {
  fetchV4Dashboard,
  setDashboardLocations,
  initializeDashboardScreen,
} from "../../redux/actions/dashboard";
import { connect } from "react-redux";
import { useEffect, useCallback } from "react";
import { loadingShow } from "../../services/PostAPI";
import DashboardComponent from "../../component/Dashboard";

function Dashboard(props) {
  const navigate = useNavigate();
  const {
    fetchV4Dashboard,
    setDashboardLocations,
    showPageLevelLoader,
    v4Data,
    selectedLocationIds,
  } = props;

  useEffect(() => {
    initializeDashboardScreen();
    fetchV4Dashboard([]);
  }, []);

  const handleLocationChange = useCallback((locationIds) => {
    setDashboardLocations(locationIds);
    fetchV4Dashboard(locationIds);
  }, [setDashboardLocations, fetchV4Dashboard]);

  let token = localStorage.getItem("token");
  if (token === "" || token == null || token === undefined) {
    return navigate("/#/");
  }

  const dashboardProps = {
    v4Data,
    selectedLocationIds,
    onLocationChange: handleLocationChange,
    isLoading: showPageLevelLoader,
  };

  loadingShow("none");

  return (
    <>
      <DashboardComponent {...dashboardProps} />
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initHolidaysScreen: () => dispatch(initializeDashboardScreen()),
    fetchV4Dashboard: (locationIds) =>
      dispatch(fetchV4Dashboard(locationIds)),
    setDashboardLocations: (ids) =>
      dispatch(setDashboardLocations(ids)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    v4Data: selectFromDashboardReducer(state, "v4Data"),
    selectedLocationIds: selectFromDashboardReducer(state, "selectedLocationIds"),
    showPageLevelLoader: selectFromDashboardReducer(state, "isLoading"),
    ...ownProps,
  };
};

const selectFromDashboardReducer = (state, path) => {
  return selectDashboardReducer(state)[path];
};

const selectDashboardReducer = ({ dashboardReducer }) => {
  return dashboardReducer;
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
